import actionTypes from '../actionTypes';

export const getDealUsers = (dealId) => ({
  type: actionTypes.DEAL_USERS_GET_REQUEST,
  dealId,
});

export const getDealUser = (dealUser) => ({
  type: actionTypes.DEAL_USER_GET_REQUEST,
  dealUser,
});

export const selectDealUser = (dealUser) => ({
  type: actionTypes.DEAL_USER_SELECT,
  dealUser,
});

export const createDealUser = (dealUser) => ({
  type: actionTypes.DEAL_USER_CREATE_REQUEST,
  dealUser,
});

export const updateDealUser = (dealUser) => ({
  type: actionTypes.DEAL_USER_UPDATE_REQUEST,
  dealUser,
});

export const deleteDealUser = (dealUser) => ({
  type: actionTypes.DEAL_USER_DELETE_REQUEST,
  dealUser,
});

export const createPublisher = (publisher) => ({
  type: actionTypes.PUBLISHER_CREATE_REQUEST,
  publisher,
});

export const updatePublisher = (publisher) => ({
  type: actionTypes.PUBLISHER_UPDATE_REQUEST,
  publisher,
});

export const deletePublisher = (publisher) => ({
  type: actionTypes.PUBLISHER_DELETE_REQUEST,
  publisher,
});



// WEBPACK FOOTER //
// src/redux/actions/dealUsers.js